import { render, staticRenderFns } from "./page.vue?vue&type=template&id=0ae62fbd&scoped=true&lang=pug&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=0ae62fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae62fbd",
  null
  
)

export default component.exports